import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import WorkflowStepType from './WorkflowStepType'
import WorkflowStepTypes from './WorkflowStepTypes'
import CreateWorkflowStepType from './CreateWorkflowStepType'

const WorkflowStepTypesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <WorkflowStepTypes />
      </Route>

      <Route path={`${path}/create-workflow-step-type`}>
        <CreateWorkflowStepType />
      </Route>

      <Route path={`${path}/:workflowStepTypeId`}>
        <WorkflowStepType />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default WorkflowStepTypesRoutes
